import { SET_CONTENT, CLEAR_CONTENT, } from "../actions/contentActions";

const initialState = {
  content: [],
}

function contentReducer(state = initialState, action) {
  switch (action.type) {
  case SET_CONTENT:
    return {
      ...state,
      content: action.payload
    }
  case CLEAR_CONTENT:
    return {
      ...state,
      content: []
    }
  default:
    return state;
  }
}

export default contentReducer;